
<template>


    <table style="width:100%;"  runat="server">
        <tr>
            <td> 
                <input type="button" class="Button" @click="OnPreviewButtonClick" value="預覽" />
            </td>
            <td align="right" style="padding-right:10px">
                <input type="button" class="Button" @click="OnOpenHtmlEditorButtonClick" value="編輯" />
            </td>
        </tr>
        <tr>
            <td colspan="2">
                <input type="hidden" :id="ContentId" name="HtmlContent" ref="Content" :value="HtmlEditorValue"  @change="OnValueChange"/>
                <div :id="ContentHtmlId" class="ContentHtml  " style="width:100%;height:300px;border:1px solid lightgray;white-space:normal;overflow:auto" v-html="HtmlEditorValue">
                </div>
            </td>
        </tr>
    </table>


</template>

<script>
    import Utility from '@/Common/Utility'


    export default {
        data() {
            return {

                ContentId: "Content",
                ContentHtmlId: "ContentHtml",
                m_ContentHtml: "",
                m_Attribute: {
                    Nullable: false,
                    Enabled: true,
                    Visible: true,
                    ReadOnly: false,
                    MaxLength: null
                }
            }
        }
        ,
        props: ["value", "Attribute"],


        computed: {
            HtmlEditorValue: function () {
                return this.m_ContentHtml;
            },

            Disabled: {

                get: function () {
                    let result = false;


                    if (this.Attribute != null && this.Attribute.Enabled != null) {
                        result = !this.Attribute.Enabled;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            }
            ,
            CssClass: {

                get: function () {
                    let result = "";

                    if (this.Attribute != null && this.Attribute.CssClass != null) {
                        result = this.Attribute.CssClass;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            }
            ,


            ReadOnly: {

                get: function () {
                    let result = false;


                    if (this.Attribute != null && this.Attribute.ReadOnly != null) {
                        result = this.Attribute.ReadOnly;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            }

            ,

            DataType: {

                get: function () {
                    let result = "text";

                    if (this.m_Attribute != null && this.m_Attribute.DataType != null) {
                        result = this.m_Attribute.DataType;
                    }

                    return result;
                }
            }
            ,


            MaxLength: {

                get: function () {
                    let result = null;

                    if (this.m_Attribute != null && this.m_Attribute.MaxLength != null) {
                        result = this.m_Attribute.MaxLength;
                    }

                    return result;
                }
            }

        },

        methods: {

            OnValueChange(e) {
                this.$emit("input", e.target.value);
                this.$emit("change", e.target.value);
            },

            UpdateElementByAttribute() {

            },

            OnButtonClick() {
                alert("Enabled = " + this.Attribute.Enabled);
            },

            OnPreviewButtonClick() {
                let width, height;
                let left, top;
                let clientId;


                clientId = this.$refs.Content;
                width = Utility.GetBrowserWidth();
                height = Utility.GetBrowserHeight();

                left = (screen.width / 2) - (800 / 2);
                top = (screen.height / 2) - (500 / 2);
                
                window.open(
                    "/ezEditor/ezEditorContentPreview?ClientId=" + this.ContentId,
                    "ContentPreview",
                    "toolbar=yes, scrollbars=yes, resizable=yes, top=" + top + ", left=" + left + ", width=800, height=500"
                );
            },

            OnOpenHtmlEditorButtonClick() {
                let windowLayout;
                let left;
                let windowTop;

                let seed = Math.floor((Math.random() * 10000) + 1);
                windowLayout = Utility.GetCenterWindowLayout(750, 500);

                left = windowLayout.X;
                windowTop = windowLayout.Y + Utility.GetScrollTop();

                this.OpenEzEditorMaskWindow(this.ContentId);
            },


            OpenEzEditorMaskWindow(contentClientId) {
                let divElement;
                let customerNoElement;
                let closeImageUrl = "/Image/Close.png";
                let seed = Math.round(Math.random() * 100000);
                let browserHeight;
                let width, height;
                let url;

                window.top.HtmlEditorSaveHandler = null;
                divElement = document.getElementById("ezEditorMaskWindow");

                width = "100%";
                height = "100%";

                if (divElement == null) {

                    divElement = document.createElement("DIV");
                    divElement.id = "ezEditorMaskWindow";


                    divElement.style.width = "100%";
                    divElement.style.height = "100%";

                    divElement.style.background = "rgba(240,240,240, 0.6)";
                    divElement.style.position = "absolute";
                    divElement.style.zIndex = 3000;
                    divElement.style.top = Utility.GetScrollTop() + "px";

                    browserHeight = Utility.GetBrowserHeight();


                    if (Utility.IsMobile()) {
                        divElement.style.height = browserHeight + "px";
                    }

                    document.body.style.overflow = "hidden";

                    //PROBLEM
                    url = "/ezEditor/ezEditorPage.html?ContentClientId=" + contentClientId;
                   
                    divElement.innerHTML = "<iframe id=\"IFrame1\" frameborder=\"0\"  scrolling=\"no\"  width=\"100%\" height=\"100%\" src=\"" + url + "\"  ></iframe></div>";

                    document.body.insertAdjacentHTML("BeforeEnd", divElement.outerHTML);

                    //document.getElementById("IFrame1Container").style.opacity = "1";

                    if (typeof (keyUpEventHandlers) != "undefined") {
                        keyUpEventHandlers.push(CloseMaskWindow);
                    }
                }
                else {

                    divElement.style.background = "rgba(0, 0, 0, 0.3)";
                    divElement.style.position = "absolute";
                    divElement.style.zIndex = 3000;

                    divElement.style.top = Utility.GetScrollTop() + "px";
                    divElement.style.left = "0px";


                    divElement.innerHTML = "<div onclick='CloseMaskWindow()' style=\"width:100%;height:100%;text-align:center;vertical-align:middle;padding-top:1 px;position:relative;overflow:hidden;\"><div id=\"IFrame1Container\" style=\"display:block;position:relative;top:50%;left:50%;max-width:" + width + ";width:100%;height:" + height + ";max-height:85%;border:" + (showBorder ? "2px solid #f8f8f8" : "none") + ";-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);-webkit-translate(-50%,-50%);opacity:1;transition:all 0.8s;-webkit-transition:all 0.8s;\" ><img src=\"/Image/Close.png\" style=\"position:absolute;top:-33px;right:0%;\" onclick=\"CloseMaskWindow()\" ><iframe id=\"IFrame1\" frameborder=\"0\"  scrolling=\"yes\"  width=\"100%\" height=\"100%\" src=\"" + url + "\"  ></iframe></div></div>";


                    frameElement = document.getElementsByTagName("iframe")[0];

                    document.body.style.overflow = "hidden";

                    maskWindowElement = document.getElementById("MaskWindow");
                    document.getElementById("IFrame1Container").style.opacity = "0.1";

                    maskWindowElement.style.display = "block";

                    iframeElemnets = document.getElementsByTagName("iframe");

                    iframeElemnet = iframeElemnets[0];

                    for (i = 0; i < iframeElemnets.length; i++) {
                        if (iframeElemnets[i].id == "IFrame1") {
                            iframeElemnet = iframeElemnets[i];
                            break;
                        }
                    }
                    document.getElementById("IFrame1Container").style.opacity = 1;
                }
 
                 window.top.HtmlEditorSaveHandler = this.OnHtmlEditorSave;
             },

            OnHtmlEditorSave(contentHtml) { 
                this.m_ContentHtml = contentHtml;

                console.log("HtmlEditor.vue emit input !");
                this.$emit("input", this.HtmlEditorValue);
                this.$emit("change", this.HtmlEditorValue);
            }


        },

        created() {

            let serialNumber;

            if (this.Attribute != null) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
            }

            serialNumber = Utility.GenerateSerialNumber();

            this.m_ContentHtml = this.value;
            this.ContentId = "Content_" + serialNumber + "_";
            this.ContentHtmlId = this.ContentId + "Html";

            this.UpdateElementByAttribute();

        },

        watch: {
            Attribute: function (newVal, oldVal) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);
            },

            value: function (newVal, oldVal) {
                if (newVal == null) {
                    this.m_ContentHtml = "";
                }
                else {
                    this.m_ContentHtml = newVal;
                }
            }
        }


    }
</script>

<style scoped>
    .ContentHtml{
        max-width:900px;
        overflow:scroll;
    }
</style>

 
